// src/components/useWakeLock.js
import { useEffect, useRef } from "react";

export default function useWakeLock(active = false) {
  const wakeLockRef = useRef(null);

  useEffect(() => {
    if (!("wakeLock" in navigator)) return;
    async function requestWakeLock() {
      try {
        wakeLockRef.current = await navigator.wakeLock.request("screen");
      } catch {}
    }
    if (active) {
      requestWakeLock();
    } else {
      if (wakeLockRef.current) {
        wakeLockRef.current.release();
        wakeLockRef.current = null;
      }
    }
    return () => {
      if (wakeLockRef.current) {
        wakeLockRef.current.release();
        wakeLockRef.current = null;
      }
    };
  }, [active]);
}
